import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/solid'; // Ensure you have heroicons installed or use similar icons available to you
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import withAnimation from '../../../hooks/withAnimation';


const conditionsList = [
  "Pre-Surgical Rehabilitation", "Post-Surgical Rehabilitation", "Vestibular Therapy",
  "Chiropractic Therapy", "TMJ Dysfunction", "Other Specialities" // Add other conditions as per your specialities
];

const OurSpecialities = () => {
  return (
    <div className="bg-background py-10 lg:py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center justify-around">
          <div className="mb-10 lg:mb-0 lg:w-1/2">
            <h2 className="text-3xl lg:text-4xl text-primary font-semibold mb-6">Explore Our<br/> Specialized Treatments</h2>
            <p className="text-lg text-gray-600">Treatments tailored to your unique needs.</p>
            {/* Uncomment below if you want to include a booking link */}
            {/* <Link
              to="/book-online"
              className="mt-8 inline-flex items-center justify-center bg-orange hover:bg-orange-dark text-white font-semibold py-3 px-6 rounded-full shadow-lg transition duration-300"
            >
              Book Online <FaExternalLinkAlt className="ml-2" />
            </Link> */}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:w-1/2">
            {conditionsList.map((condition, index) => (
              <div key={index} className="flex items-center">
                <IoMdCheckmarkCircleOutline className="h-6 w-6 text-green mr-2" />
                <span className="text-xl text-gray-800">{condition}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAnimation(OurSpecialities);